module.exports = __webpack_public_path__ + "233e37ebebc9972b59a4d1edf8f43d93.MP3";